var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3113 2.76647L6.08731 5.16647C1.23131 6.79047 1.23131 9.43847 6.08731 11.0545L8.23131 11.7665L8.94331 13.9105C10.5593 18.7665 13.2153 18.7665 14.8313 13.9105L17.2393 6.69447C18.3113 3.45447 16.5513 1.68647 13.3113 2.76647ZM13.5673 7.07047L10.5273 10.1265C10.4073 10.2465 10.2553 10.3025 10.1033 10.3025C9.95131 10.3025 9.79931 10.2465 9.67931 10.1265C9.44731 9.89447 9.44731 9.51047 9.67931 9.27847L12.7193 6.22247C12.9513 5.99047 13.3353 5.99047 13.5673 6.22247C13.7993 6.45447 13.7993 6.83847 13.5673 7.07047Z",
    fill: "#FBFAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.9bfaa2e51d09e3b13cefcb4beeda4771.svg";
export { ForwardRef as ReactComponent };